import './fullScreen.scss';
import { Button, Tooltip } from 'antd';
import Icon from 'atoms/icons/icon';
import { usePopupParent } from 'hooks/usePopupParent';
import * as React from 'react';

interface Props extends React.PropsWithChildren<any> {}

const FullScreen: React.FunctionComponent<any> = (props: Props) => {
	const getPopupParent = usePopupParent('full-screen');

	const handleToggleFullscreen = () => {
		const modalContent = document.querySelector('.app-modal--body .app-grid');
		const elem = modalContent || document.getElementById('full-screen');

		if (!elem) return;

		if (document.fullscreenElement) {
			document.exitFullscreen?.(); // optional chaining, avoids TS error
		} else if (elem.requestFullscreen) {
			elem.requestFullscreen();
		} else if ((elem as any).webkitRequestFullscreen) {
			// Safari
			(elem as any).webkitRequestFullscreen();
		} else if ((elem as any).msRequestFullscreen) {
			// IE11
			(elem as any).msRequestFullscreen();
		}
	};

	return (
		<div id="full-screen" className="fullscreen-container">
			<Button className="fullscreen-toggle-btn" size="small" onClick={handleToggleFullscreen}>
				<Tooltip title="Enable Full Screen Mode" getPopupContainer={getPopupParent}>
					{' '}
					<Icon size="small" faAlias="faExpand"></Icon>
				</Tooltip>
			</Button>
			{props.children}
		</div>
	);
};

export default FullScreen;
